// extracted by mini-css-extract-plugin
module.exports = {"switch":"ButtonsSwitch_switch__1nrHW","switch__item":"ButtonsSwitch_switch__item__9AbwZ","active":"ButtonsSwitch_active__ajqfV"};